module.exports = __webpack_public_path__ + "img/kw.34bc2795.svg";